import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1565c0',
        secondary: '#42a5f5',
        accent: '#90caf9',
        info: '#1e88e5',
        success: '#2e7d32',
        warning: '#fb8c00',
        error: '#e53935',
      },
    },
  },
});
